<!-- 				-->
<!-- Confirm Dialog -->
<!-- 				-->
<p-confirmDialog [style]="{ width: '400px' }" [baseZIndex]="10000"></p-confirmDialog>

<div class="main-group">
	<!--  	   	 	    -->
	<!-- HEADER SECTION -->
	<!-- 			    -->
	<div class="row-group">
		<div class="row-item">
			<!--  	   	 	             -->
			<!-- Visitor Status Selector -->
			<!-- 			             -->
			<div style="margin-left: 20px">
				<label>Visitor Status</label>
			</div>

			<div style="margin-left: 10px; width: 153px">
				<!-- Note: (ngModelChange) must go after [(ngModel)] or you get prev selected item!  -->
				<select
					class="form-control"
					name="SelectedStatusSelector"
					style="font-size: smaller; background-color: #ffdb7e"
					[(ngModel)]="SelectedStatus"
					(ngModelChange)="onStatusChange($event)"
					[disabled]="isAllowStatusChange == false"
				>
					<option *ngFor="let r of lstStatusItems" [ngValue]="r" style="background-color: white">
						{{ r.VisitorStatusDesc }}
					</option>
				</select>
			</div>

			<!--  	   	 	           -->
			<!-- Visitor Mark Offender -->
			<!-- 			           -->
			<div style="margin-left: 20px">
				<input type="checkbox" name="checkbox1" [(ngModel)]="rOffenderConfirmedInd" ngDefaultControl />
			</div>
			<div style="margin-left: 10px">
				<label>Place a checkmark if visitor matches any of the offenders in search results.</label>
			</div>

			<!-- 		       -->
			<!-- Update Button -->
			<!-- 		 	   -->
			<div style="margin-left: 20px">
				<button class="btn btn-primary" style="margin-left: 0px" (click)="onUpdate()" [disabled]="isBusy == true">Update</button>
			</div>
		</div>
	</div>

	<!--				-->
	<!-- Error Message  -->
	<!--				-->
	<div class="error-group" [style.display]="ErrorMessage == '' ? 'none' : 'block'">
		<div>
			<label class="error-message">{{ ErrorMessage }}</label>
		</div>
	</div>

	<!--  	   	 	 -->
	<!-- TOP SECTION -->
	<!-- 			 -->
	<div class="column-group">
		<div class="column1">
			<!-- 	       -->
			<!-- FirstName -->
			<!-- 	       -->
			<div class="column-item">
				<div>
					<label class="column-item-label">First Name</label>
				</div>

				<div style="margin-left: 10px">
					<input [disabled]="true" type="text" pInputText [(ngModel)]="rFirstName" />
				</div>
			</div>
			<!-- 		  -->
			<!-- DOB Date -->
			<!-- 		  -->
			<div class="column-item">
				<div>
					<label class="column-item-label">DOB</label>
				</div>

				<div style="margin-left: 10px">
					<p-calendar
						[disabled]="true"
						[style]="{ width: '100%' }"
						[inputStyle]="{ width: '100%' }"
						[(ngModel)]="rDOB"
						(ngModelChange)="onDOBChange($event)"
						[showTime]="false"
						hourFormat="12"
						showIcon="true"
						inputId="rdob"
					></p-calendar>
				</div>
			</div>
			<!--  	   	 	             -->
			<!-- Visitor Gender Selector -->
			<!-- 			             -->
			<div class="column-item">
				<div>
					<label class="column-item-label">Visitor Gender</label>
				</div>

				<div style="margin-left: 10px; width: 153px">
					<!-- Note: (ngModelChange) must go after [(ngModel)] or you get prev selected item!  -->
					<select
						class="form-control"
						name="SelectedGenderSelector"
						style="font-size: smaller"
						[(ngModel)]="SelectedGender"
						(ngModelChange)="onGenderChange($event)"
						[disabled]="true"
					>
						<option *ngFor="let r of lstGenderItems" [ngValue]="r">
							{{ r.GenderDesc }}
						</option>
					</select>
				</div>
			</div>
			<!-- 	        -->
			<!-- Hair Color -->
			<!-- 	        -->
			<div class="column-item">
				<div>
					<label class="column-item-label">Hair Color</label>
				</div>

				<div style="margin-left: 10px">
					<input [disabled]="true" type="text" pInputText [(ngModel)]="rHairColor" />
				</div>
			</div>
			<!-- 	       -->
			<!-- Eye Color -->
			<!-- 	       -->
			<div class="column-item">
				<div>
					<label class="column-item-label">Eye Color</label>
				</div>

				<div style="margin-left: 10px">
					<input [disabled]="true" type="text" pInputText [(ngModel)]="rEyeColor" />
				</div>
			</div>
		</div>

		<div class="column2">
			<!-- 	        -->
			<!-- MiddleName -->
			<!-- 	        -->
			<div class="column-item">
				<div>
					<label class="column-item-label">Middle Name</label>
				</div>

				<div style="margin-left: 10px">
					<input [disabled]="true" type="text" pInputText [(ngModel)]="rMiddleName" />
				</div>
			</div>
			<!-- 	    -->
			<!-- Height -->
			<!-- 	    -->
			<div class="column-item">
				<div>
					<label class="column-item-label">Height</label>
				</div>

				<div style="margin-left: 10px">
					<input [disabled]="true" type="text" pInputText [(ngModel)]="rHeight" />
				</div>
			</div>
			<!-- 	    -->
			<!-- Weight -->
			<!-- 	    -->
			<div class="column-item">
				<div>
					<label class="column-item-label">Weight</label>
				</div>

				<div style="margin-left: 10px">
					<input [disabled]="true" type="text" pInputText [(ngModel)]="rWeight" />
				</div>
			</div>
			<!-- 	   -->
			<!-- Photo -->
			<!-- 	   -->
			<div class="column-item" style="justify-content: center">
				<div class="image-view">
					<div [style.display]="Person_Image.length >= 10 ? 'block' : 'none'">
						<img class="image-view-img" [src]="Person_Image" />
					</div>
					<div [style.display]="Person_Image.length < 10 ? 'block' : 'none'">
						<label>No Image</label>
					</div>
				</div>
			</div>
		</div>

		<div class="column3">
			<!-- 	      -->
			<!-- LastName -->
			<!-- 	      -->
			<div class="column-item">
				<div>
					<label class="column-item-label">Last Name</label>
				</div>

				<div style="margin-left: 10px">
					<input [disabled]="true" type="text" pInputText [(ngModel)]="rLastName" />
				</div>
			</div>
			<!--  	   	 	           -->
			<!-- Visitor Type Selector -->
			<!-- 			           -->
			<div class="column-item">
				<div>
					<label class="column-item-label">Visitor Type</label>
				</div>

				<div style="margin-left: 10px; width: 153px">
					<!-- Note: (ngModelChange) must go after [(ngModel)] or you get prev selected item!  -->
					<select
						class="form-control"
						name="SelectedTypeSelector"
						style="font-size: smaller"
						[(ngModel)]="SelectedType"
						(ngModelChange)="onTypeChange($event)"
						[disabled]="true"
					>
						<option *ngFor="let r of lstTypeItems" [ngValue]="r">
							{{ r.VisitorTypeDesc }}
						</option>
					</select>
				</div>
			</div>
			<!-- 	 -->
			<!-- SSN -->
			<!-- 	 -->
			<div class="column-item">
				<div>
					<label class="column-item-label">SSN</label>
				</div>

				<div style="margin-left: 10px">
					<input [disabled]="true" type="text" pInputText [(ngModel)]="rSSN" />
				</div>
			</div>
			<!--  	   	 	                -->
			<!-- Visitor Ethnicity Selector -->
			<!-- 			                -->
			<div class="column-item">
				<div>
					<label class="column-item-label">Visitor Ethnicity</label>
				</div>

				<div style="margin-left: 10px; width: 153px">
					<!-- Note: (ngModelChange) must go after [(ngModel)] or you get prev selected item!  -->
					<select
						class="form-control"
						name="SelectedEthnicitySelector"
						style="font-size: smaller"
						[(ngModel)]="SelectedEthnicity"
						(ngModelChange)="onEthnicityChange($event)"
						[disabled]="true"
					>
						<option *ngFor="let r of lstEthnicityItems" [ngValue]="r">
							{{ r.EthnicityDesc }}
						</option>
					</select>
				</div>
			</div>

			<!--  	   	 	           -->
			<!-- Visitor Race Selector -->
			<!-- 			           -->
			<div class="column-item">
				<div>
					<label class="column-item-label">Visitor Race</label>
				</div>

				<div style="margin-left: 10px; width: 153px">
					<!-- Note: (ngModelChange) must go after [(ngModel)] or you get prev selected item!  -->
					<select
						class="form-control"
						name="SelectedRaceSelector"
						style="font-size: smaller"
						[(ngModel)]="SelectedRace"
						(ngModelChange)="onRaceChange($event)"
						[disabled]="true"
					>
						<option *ngFor="let r of lstRaceItems" [ngValue]="r">
							{{ r.RaceDesc }}
						</option>
					</select>
				</div>
			</div>
		</div>
	</div>

	<!--  	   	 	    -->
	<!-- BOTTOM SECTION -->
	<!-- 			    -->
	<div class="column-group" style="justify-content: center">
		<div class="column1">
			<!-- 	       -->
			<!-- Address 1 -->
			<!-- 	       -->
			<div class="column-item">
				<div>
					<label class="column-item-label">Address 1</label>
				</div>

				<div style="margin-left: 10px; width: 200px">
					<input [disabled]="true" type="text" pInputText [(ngModel)]="rStreet1" style="width: 250px" />
				</div>
			</div>
			<!-- 	       -->
			<!-- Address 2 -->
			<!-- 	       -->
			<div class="column-item">
				<div>
					<label class="column-item-label">Address 2</label>
				</div>

				<div style="margin-left: 10px">
					<input [disabled]="true" type="text" pInputText [(ngModel)]="rStreet2" style="width: 250px" />
				</div>
			</div>
			<!-- 	  -->
			<!-- City -->
			<!-- 	  -->
			<div class="column-item">
				<div>
					<label class="column-item-label">City</label>
				</div>

				<div style="margin-left: 10px">
					<input [disabled]="true" type="text" pInputText [(ngModel)]="rCity" style="width: 175px" />
				</div>
			</div>
			<!-- 	         -->
			<!-- State / ZIP -->
			<!-- 	         -->
			<div class="column-item">
				<div>
					<label class="column-item-label">State</label>
				</div>

				<div style="margin-left: 10px">
					<input [disabled]="true" type="text" pInputText [(ngModel)]="rState" style="width: 50px" />
				</div>

				<div>
					<label style="text-align: right; width: 50px">Zip</label>
				</div>

				<div style="margin-left: 10px">
					<input [disabled]="true" type="text" pInputText [(ngModel)]="rZip" style="width: 75px" />
				</div>
			</div>
		</div>

		<div class="column2">
			<!-- 	        -->
			<!-- Cell Phone -->
			<!-- 	        -->
			<div class="column-item">
				<div>
					<label class="column-item-label">Cell Phone</label>
				</div>

				<div style="margin-left: 10px">
					<input [disabled]="true" type="text" pInputText [(ngModel)]="rCellPhone" />
				</div>
			</div>
			<!-- 	        -->
			<!-- Home Phone -->
			<!-- 	        -->
			<div class="column-item">
				<div>
					<label class="column-item-label">Home Phone</label>
				</div>

				<div style="margin-left: 10px">
					<input [disabled]="true" type="text" pInputText [(ngModel)]="rHomePhone" />
				</div>
			</div>
			<!-- 	        -->
			<!-- Work Phone -->
			<!-- 	        -->
			<div class="column-item">
				<div>
					<label class="column-item-label">Work Phone</label>
				</div>

				<div style="margin-left: 10px">
					<input [disabled]="true" type="text" pInputText [(ngModel)]="rWorkPhone" />
				</div>
			</div>
			<!-- 	    -->
			<!-- e-mail -->
			<!-- 	    -->
			<div class="column-item">
				<div>
					<label class="column-item-label">e-mail</label>
				</div>

				<div style="margin-left: 10px">
					<input [disabled]="true" type="text" pInputText [(ngModel)]="rEmail" />
				</div>
			</div>
		</div>
	</div>
</div>

<!--							  -->
<!-- Show Offender Search Results -->
<!--							  -->
<div class="offender-group">
	<!--						-->
	<!-- Offender Search Filter -->
	<!--						-->
	<div class="offender-row-group">
		<div class="offender-row-item">
			<div style="margin-left: 20px">
				<label style="font-size: 12px">Offender Search Results ({{ lstOffenderLookupData.length }})</label>
			</div>

			<div style="margin-left: 25px">
				<input type="checkbox" name="chkHitOnly" [(ngModel)]="isHitOnly" (ngModelChange)="chkHitOnly($event)" ngDefaultControl />
			</div>

			<div style="margin-left: 10px">
				<label>Only show results with hits</label>
			</div>
		</div>
	</div>

	<!--						 -->
	<!-- Offender Search Results -->
	<!--						 -->
	<p-accordion>
		<p-accordionTab
			*ngFor="let rLookup of lstOffenderLookupData"
			header="{{ rLookup.LookupDate | date : 'M/d/yyyy' }} - {{ rLookup.HitItems.length }} Hit(s)"
			style="font-size: 12px"
			[selected]="false"
		>
			<div style="margin-left: 10px">
				<p-accordion>
					<p-accordionTab
						*ngFor="let rHit of rLookup.HitItems"
						header="{{ rHit.FirstName }} {{ rHit.MiddleName }} {{ rHit.LastName }} {{ rHit.Suffix }}"
						[selected]="false"
					>
						<!-- Using pTemplate="content" To Do Lazy Loading -->
						<ng-template pTemplate="content">
							<div style="margin-left: 10px; background-color: rgb(245, 245, 245)">
								<div class="column-hit-group">
									<!-- COLUMN 1 -->
									<div class="column-hit1">
										<div class="column-hit-item">
											<div class="image-hit-view">
												<div [style.display]="rHit.ImageURL?.length >= 10 ? 'block' : 'none'">
													<img class="image-hit-view-img" [src]="rHit.ImageURL" onerror="this.style.display='none'" />
												</div>
												<div [style.display]="rHit.ImageURL == null || rHit.ImageURL?.length < 10 ? 'block' : 'none'">
													<label>No Image</label>
												</div>
											</div>
										</div>
									</div>

									<!-- COLUMN 2 -->
									<div class="column-hit2">
										<div class="column-hit-item">
											<div>
												<label class="column-hit-item-label">Aliases</label>
											</div>
											<div style="margin-left: 10px">
												<label>{{ rHit.Aliases }}</label>
											</div>
										</div>
										<div class="column-hit-item">
											<div>
												<label class="column-hit-item-label">ScarsMarks</label>
											</div>
											<div style="margin-left: 10px">
												<label>{{ rHit.ScarsMarks }}</label>
											</div>
										</div>
										<div class="column-hit-item">
											<div>
												<label class="column-hit-item-label">Address</label>
											</div>
											<div style="margin-left: 10px">
												<label>{{ rHit.Address }}</label>
											</div>
										</div>
										<div class="column-hit-item">
											<div>
												<label class="column-hit-item-label">County</label>
											</div>
											<div style="margin-left: 10px">
												<label>{{ rHit.County }}</label>
											</div>
										</div>
										<div class="column-hit-item">
											<div>
												<label class="column-hit-item-label">Data Source</label>
											</div>
											<div style="margin-left: 10px">
												<label>{{ rHit.DataSource }}</label>
											</div>
										</div>

										<!--                          -->
										<!-- Bottom Section 2 Columns -->
										<!--                          -->
										<div>
											<div class="column-hit-group">
												<!-- COLUMN 1 -->
												<div class="column-hit1">
													<div class="column-hit-item">
														<div>
															<label class="column-hit-item-label">DOB</label>
														</div>
														<div style="margin-left: 10px">
															<label>{{ rHit.DOB }}</label>
														</div>
													</div>
													<div class="column-hit-item">
														<div>
															<label class="column-hit-item-label">Sex</label>
														</div>
														<div style="margin-left: 10px">
															<label>{{ rHit.Sex }}</label>
														</div>
													</div>
													<div class="column-hit-item">
														<div>
															<label class="column-hit-item-label">Race</label>
														</div>
														<div style="margin-left: 10px">
															<label>{{ rHit.Race }}</label>
														</div>
													</div>
													<div class="column-hit-item">
														<div>
															<label class="column-hit-item-label">Skintone</label>
														</div>
														<div style="margin-left: 10px">
															<label>{{ rHit.Skintone }}</label>
														</div>
													</div>
													<div class="column-hit-item">
														<div>
															<label class="column-hit-item-label">Case Number</label>
														</div>
														<div style="margin-left: 10px">
															<label>{{ rHit.CaseNumber }}</label>
														</div>
													</div>
												</div>
												<!-- COLUMN 2 -->
												<div class="column-hit2" style="margin-left: 50px">
													<div class="column-hit-item">
														<div>
															<label class="column-hit-item-label">HairColor</label>
														</div>
														<div style="margin-left: 10px">
															<label>{{ rHit.HairColor }}</label>
														</div>
													</div>
													<div class="column-hit-item">
														<div>
															<label class="column-hit-item-label">EyeColor</label>
														</div>
														<div style="margin-left: 10px">
															<label>{{ rHit.EyeColor }}</label>
														</div>
													</div>
													<div class="column-hit-item">
														<div>
															<label class="column-hit-item-label">Height</label>
														</div>
														<div style="margin-left: 10px">
															<label>{{ rHit.Height }}</label>
														</div>
													</div>
													<div class="column-hit-item">
														<div>
															<label class="column-hit-item-label">Weight</label>
														</div>
														<div style="margin-left: 10px">
															<label>{{ rHit.Weight }}</label>
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</ng-template>
					</p-accordionTab>
				</p-accordion>
			</div>
		</p-accordionTab>
	</p-accordion>
</div>

<!-- 		      -->
<!-- Close Button -->
<!-- 		      -->
<div style="margin-top: 20px">
	<button class="btn btn-primary" style="margin-left: 0px" (click)="onClose()">Cancel</button>
</div>
